export const INPUT_WAY_TAG = {
  TEXT: { title: "Input Way Text", value: "input_way_text" },
};
